var Freezer = require('freezer-js');
module.exports = new Freezer( {} );



// WEBPACK FOOTER //
// ./src/advocate/stages/quiz/state.js